import React, { useEffect, useRef, useState } from 'react';
import * as Slider from '@radix-ui/react-slider';

import 'tailwindcss/tailwind.css';

interface RangeSliderProps {
  values: number[];
  onValueChange: (values: number[]) => void;
  min: number;
  max: number;
  step: number;
  labelFormater?: (label: number) => string;
  rootClassName?: string;
  trackClassName?: string;
  rangeClassName?: string;
  thumbClassName?: string;
  labelClassName?: string;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  values,
  onValueChange,
  min,
  max,
  step,
  labelFormater,
  rootClassName = 'relative flex h-5 w-full touch-none select-none items-center',
  trackClassName = 'bg-gray relative grow rounded-full h-[0.5rem]',
  rangeClassName = 'absolute bg-yellow rounded-full h-full',
  thumbClassName = 'block h-6 w-6 rounded-full bg-yellow focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 relative',
  labelClassName = 'flex flex-wrap w-full justify-between pt-2',
}) => {
  const [internalValues, setInternalValues] = useState(values);
  const sliderRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    setInternalValues(values);
  }, [values]);

  return (
    <div id="slider-id-container" className="relative flex h-10 w-full flex-col items-start">
      <Slider.Root
        minStepsBetweenThumbs={step}
        ref={sliderRef}
        className={rootClassName}
        value={internalValues}
        onValueChange={setInternalValues}
        onValueCommit={onValueChange}
        min={min}
        max={max}
        step={step}
      >
        <Slider.Track className={trackClassName}>
          <Slider.Range className={rangeClassName} />
        </Slider.Track>
        {internalValues.map((_, index) => (
          <Slider.Thumb key={index} className={thumbClassName} />
        ))}
      </Slider.Root>
      <div className={labelClassName}>
        {internalValues.map((value, index) => (
          <div key={index}>{labelFormater ? labelFormater(value) : value}</div>
        ))}
      </div>
    </div>
  );
};

export default RangeSlider;
